import React from 'react';
import { AutoComplete } from 'primereact/autocomplete';

const PFAutoComplete = props => <AutoComplete {...props} ref={props.refs} />;

export default PFAutoComplete;
